import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./settings-asset-allocation-form.i18n";

type SettingsAssetAllocationFormProps = {
  flowLanguage: string;
  showChart: boolean;
  onShowChartChange: (show: boolean) => void;
  showTable: boolean;
  onShowTableChange: (show: boolean) => void;
  enableFollowupComparison: boolean;
  onEnableFollowupComparisonChange: (enable: boolean) => void;
};

export function SettingsAssetAllocationForm({
  flowLanguage,
  showChart,
  onShowChartChange,
  showTable,
  onShowTableChange,
  enableFollowupComparison,
  onEnableFollowupComparisonChange,
}: SettingsAssetAllocationFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="asset-alloc-show-chart" className="text-base">
            {t.showChart}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showChartDesc}</p>
        </div>
        <Switch
          id="asset-alloc-show-chart"
          checked={showChart}
          onCheckedChange={onShowChartChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="asset-alloc-show-table" className="text-base">
            {t.showTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showTableDesc}</p>
        </div>
        <Switch
          id="asset-alloc-show-table"
          checked={showTable}
          onCheckedChange={onShowTableChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="asset-alloc-followup-comparison" className="text-base">
            {t.enableFollowupComparison}
          </Label>
          <p className="text-sm text-muted-foreground">{t.enableFollowupComparisonDesc}</p>
        </div>
        <Switch
          id="asset-alloc-followup-comparison"
          checked={enableFollowupComparison}
          onCheckedChange={onEnableFollowupComparisonChange}
        />
      </div>

      {!showChart && !showTable && (
        <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md">
          {t.atLeastOneOption}
        </div>
      )}
    </div>
  );
}
